import React from 'react';
import axios from 'axios';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import ImageCard from './image_card.jsx';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    width: '100%',
  },
  headerPanel: {
   background: 'purple',
   width: '100%',
   display: 'flex',
   flexDirection: 'row',
  },
  column: {
    width: '25%',
    alignItems: 'center',

      display: 'inline-block',
    flexBasis: '25%',
  },
  gridContainer: {
      marginTop: '15px',
  },
  imagesList: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-around',
      flexFlow: 'row wrap',

      listStyleType: 'none',
      paddingLeft: 0,
  },
});

class Images extends React.Component {
    state = {
        images: [],
        loading: true
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/images`)
            .then(res => {
                console.log("IMGS", res);
                const images = res.data;
                this.setState({ images, loading: false });
            })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Typography variant="headline">Images</Typography>
                <Typography variant="subheading">These images have been ingested</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    {this.state.images.map((image, i) => 
                        <Grid item key={i}>
                            <ImageCard image={image}  />
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Images);



// WEBPACK FOOTER //
// ./src/components/images.jsx